import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import ImageIcon from '@material-ui/icons/Image';
import PeopleIcon from '@material-ui/icons/People';
import PhoneIcon from '@material-ui/icons/Phone';

import { Roles } from "../../../util/PermissionProvider";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import EventNoteIcon from '@material-ui/icons/EventNote';

// const menu = [
//   {
//     name: "Menu",
//     path: "/hkiff/menu",
//     icon: <MenuIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
//   },
//   {
//     name: "Programmes & Periods",
//     path: "/hkiff/programmes",
//     key: "programme",
//     icon: <VideoLibraryIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
//     children: [
//       {
//         name: "Programmes",
//         path: "/hkiff/programmes",
//       },
//       {
//         name: "Periods",
//         path: "/hkiff/period",
//       },
//     ],
//   },
//   { divider: true },
// ];

const menu = [
  // {
  //   name: "HKIFF",
  //   requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  // },
  {
    name: "App Version",
    path: "/hkiff-app/app-version",
    icon: <PhoneIphoneIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "App Banner",
    path: "/hkiff-app/banner",
    icon: <ImageIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Menu",
    path: "/hkiff-app/menu",
    icon: <MenuIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "About Us",
    path: "/hkiff-app/about-us",
    icon: <PeopleIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Contact Us",
    path: "/hkiff-app/contact-us",
    icon: <PhoneIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
];

export default menu;
